<template>
  <el-dialog
    append-to-body
    width="600px"
    title="添加企业"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="company_id" label="企业名称">
        <el-select
          v-model="form.data.company_id"
          size="mini"
          filterable
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      companyList: [],
      curRow: {},
      form: {
        loading: false,
        data: {
          company_id: "",
        },
        rules: {
          company_id: [
            { required: true, message: "必填项", trigger: "change" },
          ],
        },
      },
    };
  },
  methods: {
    reset(done) {
      this.isChange = false;
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.curRow = row;
      this.getCompanyList();
    },
    getCompanyList() {
      this.$http
        .get("admin/company/list", {
          params: { page: 1, count: 10000, type: 2 },
        })
        .then((res) => {
          if (res.code === 1) {
            this.companyList = res.data.list;
          }
        });
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            id: this.curRow.id,
            company_id: this.form.data.company_id,
          };
          this.$http
            .post("/admin/fair/addCompany", params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功");
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
